import { render, staticRenderFns } from "./InstrumentForm.vue?vue&type=template&id=16b7b24c"
import script from "./InstrumentForm.vue?vue&type=script&lang=js"
export * from "./InstrumentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports